import {
  BUSINESS,
  DEFAULT_DESCRIPTION,
  SITE_NAME,
  SITE_URL,
  absoluteUrl,
} from '../config/site';

const BUSINESS_ID = `${SITE_URL}/#business`;
const WEBSITE_ID = `${SITE_URL}/#website`;

function buildPostalAddress() {
  return {
    '@type': 'PostalAddress',
    streetAddress: BUSINESS.address.streetAddress,
    addressLocality: BUSINESS.address.addressLocality,
    postalCode: BUSINESS.address.postalCode,
    addressRegion: BUSINESS.address.addressRegion,
    addressCountry: BUSINESS.address.addressCountry,
  };
}

function buildBusinessNode() {
  return {
    '@type': 'ProfessionalService',
    '@id': BUSINESS_ID,
    name: SITE_NAME,
    description: DEFAULT_DESCRIPTION,
    url: SITE_URL,
    email: BUSINESS.email,
    address: buildPostalAddress(),
    founder: {
      '@type': 'Person',
      name: BUSINESS.founderName,
    },
    areaServed: {
      '@type': 'City',
      name: BUSINESS.address.addressLocality,
    },
    serviceType: BUSINESS.serviceType,
  };
}

function buildWebsiteNode() {
  return {
    '@type': 'WebSite',
    '@id': WEBSITE_ID,
    url: SITE_URL,
    name: SITE_NAME,
    description: DEFAULT_DESCRIPTION,
    inLanguage: 'en-CA',
    publisher: { '@id': BUSINESS_ID },
  };
}

function buildBreadcrumbNode(pathname, breadcrumbLabel) {
  const items = [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: SITE_URL,
    },
  ];

  if (pathname !== '/') {
    items.push({
      '@type': 'ListItem',
      position: 2,
      name: breadcrumbLabel,
      item: absoluteUrl(pathname),
    });
  }

  return {
    '@type': 'BreadcrumbList',
    '@id': `${absoluteUrl(pathname)}#breadcrumb`,
    itemListElement: items,
  };
}

export function buildPageJsonLd(pathname, breadcrumbLabel) {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      buildBusinessNode(),
      buildWebsiteNode(),
      buildBreadcrumbNode(pathname, breadcrumbLabel),
    ],
  };
}
